"use strict";

import angular from "angular";

import _ from "lodash";

export class ContractService {
    constructor(AccountingFactory) {
        this.AccountingFactory = AccountingFactory;
    }

    /**
     * @public
     * Classifica se e pertimido ou não um contrato de acordo com a lista
     * @param {Array} contract
     * @returns {Boolean}
     */
    isContracted(contracts) {
        const accounting = this.AccountingFactory.getDocument();
        const accountingContract = _.get(accounting, "contract") || "";

        if (contracts.includes(accountingContract)) return false;
        else return true;
    }

    /**
     * @public
     * Cuida do source que ira ser retornado nos direecionamentos padrão
     * @param {String} referenceSource
     * @returns
     */
    sourceDefault(referenceSource) {
        if (!this.isContracted(["Starter"])) {
            defaultSource =
                referenceSource == "accounting"
                    ? "financeiro"
                    : referenceSource || "financeiro";
        } else if (userRoles == "Pessoal") {
            defaultSource = "pessoal";
        } else if (userRoles == "Fiscal" || userRoles == "Pessoal e Fiscal") {
            defaultSource = "fiscal";
        } else if (userRoles == "Financeiro") {
            defaultSource = "financial";
        } else {
            defaultSource = referenceSource || "contabil";
        }

        return defaultSource;
    }
}

angular
    .module("nucont.shared")
    .service("ContractService", ["AccountingFactory", ContractService]);
